import React, { useState } from 'react'
import { Card, CardContent, Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import EthernetConfigurationSection from '../ConfigurationSections/EthernetConfigurationSection'
import GsmConfigurationSection from '../ConfigurationSections/GsmConfigurationSection'
import { FormTabProps } from '../../types/FormTab.types'

const NetworkTab = ({ formState, handleChangeByShadow }: FormTabProps) => {
    const [currentTab, setCurrentTab] = useState('Ethernet')

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setCurrentTab(newValue)
    }

    return (
		<Box className="sub-card-container" sx={{ height: "100%" }}>
            <TabContext value={currentTab}>
            <TabList
                orientation="vertical"
                onChange={handleTabChange}
                sx={{ width: "174px" }}>
				<Tab
					label="Ethernet"
					value="Ethernet"
					className="sub-card-tab"
					sx={{ color: "#858585" }}
				/>
				<Tab
					label="GSM"
					value="GSM"
					className="sub-card-tab"
					sx={{ color: "#858585" }}
				/>
			</TabList>
			<Card
				sx={{ width: "77%", p: 0 }}
				variant="outlined"
				className="card-configuration"
			>
				<CardContent sx={{ p: 2 }} className="card-configuration">
					<TabPanel value="Ethernet" sx={{ p: 0 }} className="configuration-option">
						<EthernetConfigurationSection
                            formState={formState}
                            handleChangeByShadow={handleChangeByShadow}
                        ></EthernetConfigurationSection>
					</TabPanel>

                    <TabPanel value="GSM" sx={{ p: 0 }} className="configuration-option">
                        <GsmConfigurationSection
                            formState={formState}
                            handleChangeByShadow={handleChangeByShadow}
                        ></GsmConfigurationSection>
                    </TabPanel>

				</CardContent>
			</Card>
            </TabContext>
		</Box>
	);
};

export default NetworkTab;
